import { useState, useCallback, useRef } from "react";
import {
  openSession,
  setHandoffToken,
} from "../services/mobileCaptureApi";

interface SessionInfo {
  doc_type: string;
  issuing_country: string;
  requires_back: boolean;
  status: string;
}

export const useHandoffAuth = (sessionToken: string) => {
  const [handoffToken, setHandoffTokenLocal] = useState<string | null>(null);
  const [sessionInfo, setSessionInfo] = useState<SessionInfo | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const isOpeningRef = useRef(false);

  const open = useCallback(async () => {
    if (isOpeningRef.current) return;
    isOpeningRef.current = true;

    try {
      const data = await openSession(sessionToken);
      setHandoffToken(data.handoffToken);
      setHandoffTokenLocal(data.handoffToken);
      setSessionInfo(data.session);
      setError(null);
    } catch (err: any) {
      const msg =
        err.response?.data?.message || "Failed to open session";
      setError(msg);
    } finally {
      setIsLoading(false);
      isOpeningRef.current = false;
    }
  }, [sessionToken]);

  const clear = useCallback(() => {
    setHandoffToken(null);
    setHandoffTokenLocal(null);
    setSessionInfo(null);
  }, []);

  return {
    handoffToken,
    sessionInfo,
    isLoading,
    error,
    open,
    clear,
  };
};
